<template>
  <div v-if="report.companyoverview.creditreport">
    <report-panel :anchor="anchor">
      <div slot="title">Credit Scores</div>
      <div slot="body">
        <!-- panel content start -->
        <table class="table table-striped" id="credit-score-table">
          <thead>
            <tr>
              <th>Since Date</th>
              <th class="text-right">Score</th>
              <th>Commentary</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">
                {{ formatDate(report.companyoverview.creditreport.credit_limit_since_date) }}
              </th>
              <td class="text-right">
                {{ report.companyoverview.creditreport.credit_score_value }}
              </td>
              <td>{{ report.companyoverview.creditreport.credit_score_description }}</td>
            </tr>
          </tbody>
        </table>
        <!-- panel content end -->
      </div>
    </report-panel>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanel from '@/components/reports/components/ReportPanel';

export default {
  components: {
    ReportPanel,
  },
  mixins: [toolsMixin],
  props: ['report', 'showAnchor'],
  computed: {
    anchor() {
      if (this.showAnchor) {
        return '#credit';
      }
      return '';
    },
  },
};
</script>
